import { MAP_TYPES } from '@deck.gl/carto';

const HISTORICALMOOVEAI_SOURCE_ID = 'historicalMooveAiSource';

const source = {
  id: HISTORICALMOOVEAI_SOURCE_ID,
  type: MAP_TYPES.TABLE,
  connection: 'caltrans-vru',
  data: 'us-con-gcp-npr-0000401-072324.moove_ai_shared_datasets.all_near_misses_h3_bins',
};

export default source;
